'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _YellowLineSVG = require('../../svg/YellowLineSVG');

var _YellowLineSVG2 = _interopRequireDefault(_YellowLineSVG);

var _BlockWrapper = require('./components/BlockWrapper');

var _BlockWrapper2 = _interopRequireDefault(_BlockWrapper);

var _Link = require('./components/Link');

var _Link2 = _interopRequireDefault(_Link);

var _Title = require('./components/Title');

var _Title2 = _interopRequireDefault(_Title);

var _Wrapper = require('./components/Wrapper');

var _Wrapper2 = _interopRequireDefault(_Wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
# NewsCTA
A CTA containing list of links to news items.
 */
var NewsCTA = function NewsCTA(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === undefined ? 'OSBA News' : _ref$title,
      links = _ref.links;

  var parsedLinks = JSON.parse(links);

  var transformedLinks = parsedLinks.map(function (link, index) {
    return _extends({
      id: index
    }, link);
  });

  return _react2.default.createElement(
    _BlockWrapper2.default,
    null,
    _react2.default.createElement(
      _Wrapper2.default,
      null,
      _react2.default.createElement(_YellowLineSVG2.default, null),
      _react2.default.createElement(
        _Title2.default,
        null,
        title
      ),
      transformedLinks.map(function (link) {
        return (
          /* eslint-disable */
          // not sure why this is throwing an error for jsx-a11y/anchor-is-valid. It's not an anchor...
          _react2.default.createElement(_Link2.default, {
            key: link.id,
            label: link.Title,
            url: link.Href
          })
          /* eslint-enable */

        );
      })
    )
  );
};

NewsCTA.propTypes = {
  /** the title. */
  title: _propTypes2.default.string,
  /** the links to the news items. */
  links: _propTypes2.default.string.isRequired
};

NewsCTA.displayName = 'NewsCTA';

exports.default = NewsCTA;
NewsCTA.__docgenInfo = {
  'description': '# NewsCTA\r\nA CTA containing list of links to news items.',
  'methods': [],
  'displayName': 'NewsCTA',
  'props': {
    'title': {
      'defaultValue': {
        'value': '\'OSBA News\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'the title.'
    },
    'links': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'the links to the news items.'
    }
  }
};